import createAxiosInstance from './createAxiosInstance'

const corePath = process.env.VUE_APP_CORE_URL
const coreInstance = createAxiosInstance(corePath)

export const apiCore = {
  getCommunityMainService: () => coreInstance.get('/api/Community/CommunityMainService'), // 取得各種功能、功能卡片之開關
  useSnOpenAccount: (data, config) => coreInstance.post('/api/AuthorizationSn/UseSnOpenAccount', data, config) // 使用開通序號開通社區
}
